import clsx from 'clsx';
import type * as React from 'react';

import { DataTestIds } from '@repo/frontend-shared';

interface SDSTableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
  isHeader?: boolean;
  clickable?: boolean;
  ref?: React.Ref<HTMLTableRowElement>;
}

export function SDSTableRow({
  children,
  isHeader = false,
  clickable = false,
  className,
  onClick,
  ref,
  ...props
}: SDSTableRowProps) {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (clickable && onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.currentTarget.click();
    }
  };

  return (
    <tr
      ref={ref}
      className={clsx(
        'SDSTableRow',
        {
          'SDSTableRow--header': isHeader,
          'SDSTableRow--clickable': clickable,
        },
        className,
      )}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : undefined}
      data-testid={DataTestIds.SDS.SDS_TABLE_ROW}
      {...props}
    >
      {children}
    </tr>
  );
}
